/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBackpack} from '@fortawesome/pro-duotone-svg-icons';

const AssignmentIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBackpack} {...props} />
);

export default AssignmentIcon;
